<template>
  <div class="row" id="translateForm">
    <div class="col-md-6 col-md-offset-3">
    <form id="form" class="well form-inline" v-on:submit="formSubmit">
      <input type="text" id="input" class="form-control" v-model="textToTranslate" placeholder="Enter some word">
      <select class="form-control" v-model="language" id="list">
        <option value="en">English</option>
        <option value="hi">Hindi</option>
          <option value="pa">Punjabi</option>
          <option value="fr">French</option>
            <option value="zh">Chinese</option>
        <option value="ja">Japanese</option>
        <option value="mr">Marathi</option>
      <option value="bn">Bengali</option>
        <option value="az">Azerbaijan</option>
        <option value="sq">Albanian</option>
          <option value="am">Amharic</option>
          <option value="ar">Arabic</option>
            <option value="hy">Armenian</option>
            <option value="af">Afrikaans</option>
            <option value="eu">Basque</option>
            <option value="ba">Bashkir</option>
            <option value="be">Belarusian</option>
            <option value="my">Burmese</option>
            <option value="bg">Bulgarian</option>
            <option value="bs">Bosnian</option>
            <option value="cy">Welsh</option>
            <option value="hu">Hungarian</option>
            <option value="vi">Vietnamese</option>
            <option value="ht">Haitian (Creole)</option>
            <option value="gl">Galician</option>
            <option value="nl">Dutch</option>
            <option value="mrj">Hill Mari</option>
            <option value="el">Greek</option>
            <option value="ka">Georgian</option>
            <option value="gu">Gujarati</option>
            <option value="da">Danish</option>
            <option value="he">Hebrew</option>
            <option value="yi">Yiddish</option>
            <option value="id">Indonesian</option>
            <option value="ga">Irish</option>
            <option value="it">Italian</option>
            <option value="is">Icelandic</option>
            <option value="es">Spanish</option>
            <option value="kk">Kazakh</option>
            <option value="kn">Kannada</option>
            <option value="ca">Catalan</option>
            <option value="ky">Kyrgyz</option>
            <option value="ko">Korean</option>
            <option value="la">Latin</option>
            <option value="ml">Malayalam</option>
            <option value="ne">Nepali</option>
            <option value="no">Norwegian</option>
            <option value="fa">Persian</option>
            <option value="pl">Polish</option>
            <option value="pt">Portuguese</option>
            <option value="ru">Russian</option>
            <option value="ta">Tamil</option>
            <option value="tr">Turkish</option>
            <option value="ur">Urdu</option>
            <option value="sv">Swedish</option>
            <option value="te">Telugu</option>
            <option value="gd">Scottish</option>




      </select>
      <input type="submit" class="btn btn-primary" value="Translate">
    </form>
  </div>
  </div>
</template>

<script>

export default {
  name: 'translateForm',
  data(){
    return {
      textToTranslate : '',
      language:''
    }
  },
  created(){
    this.language = 'en';
  },
  methods:{
    formSubmit(e){
      this.$emit('formSubmit',this.textToTranslate,this.language);
      e.preventDefault();
    }
  }
}

</script>

<style>
#form{
  border-radius:8px;
  border:1px solid #ccc;
}
#input,#list{
  margin:12px;
}
</style>



// WEBPACK FOOTER //
// TranslateForm.vue?7457f0fa